import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'eventq-user-bar',
  imports: [MatIcon],
  templateUrl: './user-bar.html',
  styleUrl: './user-bar.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqUserBar {
  readonly email = input.required<string>();

  readonly logout = output<void>();
}
